// extracted by mini-css-extract-plugin
export default {"form":"GVKH2wd","fieldset":"FQ6m3Es","disclaimer":"ceKWg8u","divider":"YmcQnK1","applyButton":"kJtUecT"};